import http from "../utils/http-common";

class TaxRatesDataService {
  async getAll() {
    const resp = await http.get("/tax-rates");
    resp.data.rows = resp.data.rows.map((r) => { return { ...r, name: r.name + ` (${r.rate})` } })
    return resp;
  }

  get(id) {
    return http.get(`/tax-rates/${id}`);
  }

  create(data) {
    return http.post("/tax-rates", data);
  }

  update(id, data) {
    return http.put(`/tax-rates/${id}`, data);
  }

  delete(id) {
    return http.delete(`/tax-rates/${id}`);
  }
}

export default new TaxRatesDataService();